import React, { useState, useEffect } from "react";
import { Button, Col, Form, InputGroup } from "react-bootstrap";
import { connect } from "react-redux";
import AppSpinner from "../Extras/AppSpinner/AppSpinner";
import { formatMoney } from "../../utils/formatMoney";
import {
  wompiBaseUrl,
  wompiPublicKey,
  redirectBaseUrl,
  pciVaultUrl,
  pciVaultPassphrase,
  pciVaultPassword,
  pciVaultUser,
  epaycoBaseUrl,
  epaycoIsTest,
  epaycoPrivateKey,
  epaycoPublicKey,
} from "../../utils/paymentKeys";
import { apiUrl, businessName } from "../../utils/consts";
import { withRouter } from "react-router";
import "./styles/cardPayment.scss";

const select = (state) => {
  return {
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token,
  };
};

function ConnectedCardPayment(props) {
  const [loading, setLoading] = useState(true);
  const [creatingTransaction, setCreatingTransaction] = useState(false);
  const [validated, setValidated] = useState(false);
  const [acceptanceToken, setAcceptanceToken] = useState(null);
  const [permalink, setPermalink] = useState(null);
  const [transactionStatus, setTransactionStatus] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardHolderLastName, setCardHolderLastName] = useState("");
  const [userIdentification, setUserIdentification] = useState("");
  const [userIdentificationType, setUserIdentificationType] = useState("CC");
  const [cellPhone, setCellPhone] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cvv, setCvv] = useState("");
  const [cardExpirationMonth, setCardExpirationMonth] = useState("");
  const [cardExpirationYear, setCardExpirationYear] = useState("");
  const [installments, setInstallments] = useState(1);
  const [saveCard, setSaveCard] = useState(false);
  const [savedPaymentSource, setSavedPaymentSource] = useState("Ninguna");
  let interval;

  useEffect(() => {
    getWompiData();
  }, []);

  useEffect(() => {
    if (acceptanceToken && permalink) setLoading(false);
  }, [acceptanceToken, permalink]);

  useEffect(() => {
    if (transactionStatus) {
      setCreatingTransaction(false);

      if (transactionStatus === "SUCCESS" && props.onTransactionSuccess)
        props.onTransactionSuccess();
    }
  }, [transactionStatus]);

  useEffect(() => {
    if (transactionId) interval = setInterval(checkEpaycoTransaction, 2000);
  }, [transactionId]);

  const getWompiData = async () => {
    const acceptanceTokenResp = await fetch(
      `${wompiBaseUrl}/merchants/${wompiPublicKey}`
    );
    const acceptanceTokenData = await acceptanceTokenResp.json();
    const { data } = acceptanceTokenData;

    if (data) {
      const presignedData = data.presigned_acceptance;

      setAcceptanceToken(presignedData.acceptance_token);
      setPermalink(presignedData.permalink);
    }
  };

  /* const checkTransaction = async () => {
    if (!transactionStatus) {
      try {

        const transactionResponse = await fetch(`${wompiBaseUrl}/transactions/${transactionId}`);
        const transaction = await transactionResponse.json();

        const { data } = transaction;

        if (data && data.status !== 'PENDING') {
          clearInterval(interval);
          setTransactionStatus(data.status === 'APPROVED' ? 'SUCCESS' : 'ERROR');
        }

      } catch (err) {
        clearInterval(interval);
        setTransactionStatus('ERROR');
      }
    }
  }; */
  const getTokenApify = async () => {
    const tokenApifyResponse = await fetch(`${epaycoBaseUrl}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          new Buffer.from(epaycoPublicKey + ":" + epaycoPrivateKey).toString(
            "base64"
          ),
      },
    });

    const tokenApifyData = await tokenApifyResponse.json();
    return tokenApifyData.token;
  };

  const checkEpaycoTransaction = async () => {
    if (!transactionStatus) {
      try {
        const token_apify = await getTokenApify();

        const transactionResponse = await fetch(
          `${epaycoBaseUrl}/payment/transaction`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token_apify}`,
            },
            body: JSON.stringify({
              referencePayco: transactionId,
            }),
          }
        );
        const transaction = await transactionResponse.json();
        const { data } = transaction;
        if (data && data.response !== "Pendiente") {
          clearInterval(interval);
          setTransactionStatus("SUCCESS");
        } else {
          //Enviar log a BD
          await fetch("/nibiLogs/create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              content: transaction,
              userId: props.userId,
              context: "Transacción no aceptada en Cemex",
            }),
          });
        }
      } catch (err) {
        clearInterval(interval);
        setTransactionStatus("ERROR");
      }
    }
  };

  const createCardPayment = async () => {
    const {
      token,
      userId,
      products,
      amount,
      deliveryInfo,
      paymentType,
      benefitCategory,
      benefitApplicationId,
      requestedBenefitId,
    } = props;

    const body = {
      userId,
      businessName,
      token,
      products,
      amount,
      paymentMethod: "CARD",
      paymentType,
      benefitCategory,
      benefitApplicationId,
      requestedBenefitId,
    };

    if (products && products.length > 0 && deliveryInfo) {
      body.deliveryInfo =
        deliveryInfo.street +
        " " +
        (deliveryInfo.extra ? deliveryInfo.extra : "") +
        " " +
        (deliveryInfo.area ? deliveryInfo.area : "") +
        ", " +
        deliveryInfo.city +
        ", " +
        deliveryInfo.state +
        ", " +
        deliveryInfo.country +
        ", " +
        deliveryInfo.phone;
    }

    const paymentResponse = await fetch(`${apiUrl}/payments/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const paymentData = await paymentResponse.json();
    const { reference } = paymentData;

    return reference;
  };

  /* const createTransaction = async () => {

    const { amount, userId, token, user } = props;

    if (savedPaymentSource === 'Ninguna') {
      const cardTokenId = await tokenizeCard();

      if (!cardTokenId) return;

      if (saveCard) {
        fetch(`${apiUrl}/payments/save_card`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId,
            token,
            businessName,
            cardToken: cardTokenId,
            cardNumber: cardNumber.substring(cardNumber.length - 4)
          })
        });
      }

      const reference = await createCardPayment();

      const transactionResponse = await fetch(`${wompiBaseUrl}/transactions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${wompiPublicKey}`
        },
        body: JSON.stringify({
          acceptance_token: acceptanceToken,
          amount_in_cents: parseInt(`${amount}00`),
          currency: 'COP',
          customer_email: user.email,
          payment_method: {
            type: 'CARD',
            installments: parseInt(installments),
            token: cardTokenId
          },
          reference
        })
      });

      const transtactionData = await transactionResponse.json();

      if (transtactionData.data) {
        return transtactionData.data.id;
      } else {
        setTransactionStatus('ERROR');
      }

    } else {
      const reference = await createCardPayment();

      const transactionResponse = await fetch(`${apiUrl}/payments/create/payment_source`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          amount,
          savedPaymentSource,
          userEmail: user.email,
          reference
        })
      });

      const transactionData = await transactionResponse.json();

      if (!transactionData.success) {
        setTransactionStatus('ERROR');
      } else {
        return transactionData.transactionId;
      }

    }
  }; */

  const createTransactionEpayco = async () => {
    const { amount, userId, token, user } = props;

    try {
      if (savedPaymentSource === "Ninguna") {
        let saveCardFetch;
        if (saveCard) {
          const tokenizeCardResponse = await fetch(
            `${pciVaultUrl}/vault?user=NIBI&key=${pciVaultPassphrase}`,
            {
              method: "POST",
              body: JSON.stringify({
                card_expiry: `${cardExpirationMonth}-20${cardExpirationYear}`,
                card_holder: cardHolderName + " " + cardHolderLastName,
                card_number: cardNumber,
                cvv: cvv,
              }),
              headers: {
                Authorization:
                  "Basic " +
                  new Buffer.from(
                    pciVaultUser + ":" + pciVaultPassword
                  ).toString("base64"),
                "Content-Type": "application/json",
              },
            }
          );

          const tokenCardData = await tokenizeCardResponse.json();
          if (tokenCardData.token) {
            saveCardFetch = fetch(`${apiUrl}/payments/save_card`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                userId,
                token,
                businessName,
                cardNumber: cardNumber.substring(cardNumber.length - 4),
                creditCardToken: tokenCardData.token,
              }),
            });
          } else {
            //Enviar log a BD
            await fetch(`/nibiLogs/create`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                content: tokenCardData,
                userId: userId,
                context: "Error al guardar tarjeta PCI pago en Cemex",
              }),
            });
          }
        }

        const reference = await createCardPayment();
        const token_apify = await getTokenApify();

        const body = JSON.stringify({
          value: `${parseInt(parseInt(amount))}`,
          docType: userIdentificationType,
          docNumber: userIdentification,
          name: cardHolderName,
          lastName: cardHolderLastName,
          email: user.email,
          cellPhone: cellPhone,
          phone: cellPhone,
          cardNumber: cardNumber,
          cardExpYear: "20" + cardExpirationYear,
          cardExpMonth: cardExpirationMonth,
          cardCvc: cvv,
          dues: `${installments}`,
          redirect_url: `${redirectBaseUrl}/pago/resultado`,
          testMode: epaycoIsTest,
          extra1: reference,
          extra2: `Pago en cemex de usuario con id: ${userId}`,
        });

        const transactionResponse = await fetch(
          `${epaycoBaseUrl}/payment/process`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token_apify}`,
            },
            body,
          }
        );

        const transactionData = await transactionResponse.json();
        if (
          transactionData.data.transaction.data.estado === "Aceptada" &&
          transactionData.data.transaction
        ) {
          if (saveCardFetch) {
            const response = await saveCardFetch;
            await response.json();
          }
          if (saveCard) {
            if (
              transactionData.data.tokenCard.cardTokenId != "N/A" &&
              transactionData.data.tokenCard.cardTokenId != ""
            ) {
              await fetch(`${apiUrl}/payments/save_epayco_card`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  token,
                  businessName,
                  epaycoToken: transactionData.data.tokenCard.cardTokenId,
                  userId,
                  cardNumber: cardNumber.substring(cardNumber.length - 4),
                }),
              });
            }
          }
          return transactionData.data.transaction.data.ref_payco;
        } else {
          //Enviar log a BD
          await fetch(`/nibiLogs/create`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              content: transactionData,
              userId: userId,
              context: "Transacción no aceptada en pago Cemex",
            }),
          });
          setTransactionStatus("ERROR");
        }
      } else {
        const reference = await createCardPayment();

        const transactionResponse = await fetch(
          `${apiUrl}/payments/create/payment_source`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              token,
              businessName,
              amount,
              savedPaymentSource,
              userEmail: user.email,
              reference,
              userId,
              cardHolderName,
              cardHolderLastName,
              cellPhone,
              userIdentification,
              userIdentificationType,
            }),
          }
        );

        const transactionData = await transactionResponse.json();

        if (!transactionData.success) {
          setTransactionStatus("ERROR");
          setCreatingTransaction(false);
          //Enviar log a BD
          await fetch(`/nibiLogs/create`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              content: transactionData,
              userId: userId,
              context:
                "Error en /payments/transaction/create/payment_source desde Cemex",
            }),
          });
        } else {
          return transactionData.transactionId;
        }
      }
    } catch (e) {
      console.log(e);
      //Enviar log a BD
      await fetch(`/nibiLogs/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: e,
          userId: userId,
          context: "Error en pago Cemex",
        }),
      });
      setTransactionStatus("ERROR");
      setCreatingTransaction(false);
    }
  };

  /* const tokenizeCard = async () => {
    const tokenizeCardResponse = await fetch(`${wompiBaseUrl}/tokens/cards`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${wompiPublicKey}`,
      },
      body: JSON.stringify({
        number: cardNumber,
        cvc: cvv,
        exp_month: cardExpirationMonth,
        exp_year: cardExpirationYear,
        card_holder: cardHolderName,
      }),
    });

    const tokenCardData = await tokenizeCardResponse.json();

    if (
      tokenizeCardResponse.status === 201 &&
      tokenCardData.status === "CREATED"
    )
      return tokenCardData.data.id;
    else setTransactionStatus("ERROR");
  }; */

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {
      setCreatingTransaction(true);
      const transactionId = await createTransactionEpayco();

      if (transactionId) setTransactionId(transactionId);
    }
  };

  const finishTransaction = () => {
    props.history.push("/");
    if (props.onFinishTransaction) props.onFinishTransaction();
  };

  if (loading || creatingTransaction) {
    return (
      <div className="card-payment-component">
        <AppSpinner />
        {creatingTransaction && (
          <h4 className="transaction-message">
            Estamos procesando la transacción. Por favor espera.
          </h4>
        )}
      </div>
    );
  }

  if (transactionStatus) {
    return (
      <div className="card-payment-component">
        <h3 className="transaction-message transaction-status-message">
          {transactionStatus === "SUCCESS" ? (
            <>
              Gracias por usar nibi.
              <br />
              Recibimos tu pago por un valor de ${formatMoney(
                props.amount
              )}{" "}
              COP.
              <Button
                className="app-button"
                style={{ width: "fit-content", marginTop: "15px" }}
                onClick={finishTransaction}
              >
                Volver a la página principal
              </Button>
            </>
          ) : (
            "Error al procesar la transacción. Inténtalo nuevamente o comunícate con nosotros."
          )}
        </h3>
      </div>
    );
  }

  const paymentSources = props.user.creditCards || [];

  return (
    <div className="card-payment-component">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} lg={6}>
            <Form.Label>Monto</Form.Label>
            <Form.Control value={formatMoney(props.amount)} disabled={true} />
          </Form.Group>
          {paymentSources.length > 0 && (
            <Form.Group as={Col} lg={6}>
              <Form.Label>Usar tarjeta guardada</Form.Label>
              <Form.Control
                as="select"
                name="savedPaymentSource"
                value={savedPaymentSource}
                onChange={(event) => setSavedPaymentSource(event.target.value)}
              >
                <option value="Ninguna">Ninguna</option>
                {paymentSources.map((el, index) => (
                  <option key={index} value={el.paymentSourceId}>
                    **** **** **** {el.cardNumber}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          )}
          <Form.Group as={Col} lg={6}>
            <Form.Label>Nombre(s)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nombres(s)"
              value={cardHolderName}
              onChange={(event) => setCardHolderName(event.target.value)}
              required
            />
          </Form.Group>
          <Form.Group as={Col} lg={6}>
            <Form.Label>Apellido(s)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Apellido(s)"
              value={cardHolderLastName}
              onChange={(event) => setCardHolderLastName(event.target.value)}
              required
            />
          </Form.Group>
          <Form.Group as={Col} lg={4}>
            <Form.Label>
              <small>Número de Teléfono</small>
            </Form.Label>
            <Form.Control
              name="cellPhone"
              type="text"
              placeholder="Teléfono"
              value={cellPhone}
              onChange={(event) => setCellPhone(event.target.value)}
              required
            />
          </Form.Group>
          <Form.Group as={Col} lg={4}>
            <Form.Label>
              <small>Tipo de documento</small>
            </Form.Label>
            <Form.Control
              name="userIdentificationType"
              as="select"
              value={userIdentificationType}
              onChange={(event) =>
                setUserIdentificationType(event.target.value)
              }
            >
              <option value="CC">CC</option>
              <option value="NIT">NIT</option>
              <option value="CE">CE</option>
              <option value="Otro">Otro</option>
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} lg={4}>
            <Form.Label>
              <small>Número de documento</small>
            </Form.Label>
            <Form.Control
              name="userIdentification"
              type="text"
              placeholder="Documento"
              value={userIdentification}
              onChange={(event) => setUserIdentification(event.target.value)}
              required
            />
            <Form.Control.Feedback type="invalid">
              Ingresa tu documento.
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
        {savedPaymentSource === "Ninguna" && (
          <Form.Row>
            <Form.Group as={Col} lg={6}>
              <Form.Label>Número de la tarjeta</Form.Label>
              <Form.Control
                type="number"
                placeholder="0000 0000 0000 0000"
                value={cardNumber}
                onChange={(event) => setCardNumber(event.target.value)}
                required
              />
            </Form.Group>

            <Form.Group as={Col} lg={4}>
              <Form.Label>Fecha de expiración</Form.Label>
              <InputGroup>
                <Form.Control
                  type="number"
                  placeholder="MM"
                  min={1}
                  max={12}
                  value={cardExpirationMonth}
                  onChange={(event) => {
                    const { value } = event.target;
                    if (value.toString().length <= 2)
                      setCardExpirationMonth(value);
                  }}
                  required
                />
                <Form.Control
                  type="number"
                  min={20}
                  placeholder="YY"
                  value={cardExpirationYear}
                  onChange={(event) => {
                    const { value } = event.target;
                    if (value.toString().length <= 2)
                      setCardExpirationYear(value);
                  }}
                  required
                />
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} lg={4}>
              <Form.Label>Código de seguridad</Form.Label>
              <Form.Control
                type="number"
                value={cvv}
                onChange={(event) => setCvv(event.target.value)}
                required
              />
            </Form.Group>

            <Form.Group as={Col} lg={4}>
              <Form.Label>Número de cuotas</Form.Label>
              <Form.Control
                type="number"
                min={1}
                max={36}
                value={installments}
                onChange={(event) => setInstallments(event.target.value)}
                required
              />
            </Form.Group>
            {savedPaymentSource === "Ninguna" && (
              <Form.Group as={Col} xs={12}>
                <div className="custom-control custom-checkbox">
                  <input
                    id="saveCardCheckbox"
                    type="checkbox"
                    className="custom-control-input"
                    onChange={(event) => setSaveCard(event.target.checked)}
                    checked={saveCard}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="saveCardCheckbox"
                  >
                    Deseo guardar mi tarjeta de crédito para futuras
                    transacciones.
                  </label>
                </div>
              </Form.Group>
            )}
          </Form.Row>
        )}

        <Form.Row>
          <Col xs={12}>
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id="permalinkCheckBox1"
                required
              />
              <label
                className="custom-control-label"
                htmlFor="permalinkCheckBox1"
              >
                Acepto haber leído los{" "}
                <a href={permalink} target="_blank" rel="noopener noreferrer">
                  términos y condiciones y la política de privacidad
                </a>{" "}
                para hacer este pago.
              </label>
            </div>
          </Col>

          <Button
            className="app-button"
            type="submit"
            style={{ marginTop: "15px" }}
          >
            Continuar
          </Button>
        </Form.Row>
      </Form>
    </div>
  );
}

const CardPayment = connect(select)(ConnectedCardPayment);

export default withRouter(CardPayment);
